import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TrainingAddToCart from '../TrainingAddToCart';
import PaymentHistory from '../PaymentHistory';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TraningCartTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const params = window.location.pathname



  useEffect(() => {

    setValue(params == "/QuizPayments" ? 1 : 0);

  }, [params]);
  return (
    <Box sx={{ width: '100%', padding: "10px" ,overflowX:"hidden"}}>
      <span style={{ fontSize: "28px", color: "#101828", fontWeight: "600", marginLeft: "12px" }}>Training</span>
      <Box >
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab sx={{ marginLeft: 3 }} label="Add Training Courses" {...a11yProps(0)} />
          <Tab label="Payment History" {...a11yProps(1)} />

        </Tabs>
      </Box>
      <TabPanel value={value} index={0} sx={{ padding: 0 }}>
        <TrainingAddToCart />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PaymentHistory />
      </TabPanel>

    </Box>
  )
}
